import React from 'react'
import { Typography, Chip, Avatar, Tooltip, Zoom, Hidden, Box, Card, CardContent, CardMedia } from '@material-ui/core'
import { Trans } from 'react-i18next'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import moment from 'moment'
import RoomIcon from '@material-ui/icons/Room'
import { pictureUrl } from '../common/pictureUrl'
import { getWilayasFromTranslation } from '../common/getWilayasFromTranslation'
import { useStyles } from '../../pages/index'

const StatusChip = (props) => <Chip color="secondary" variant="outlined" {...props} />

export const Post = ({ offer }) => {
  const classes = useStyles()
  const router = useRouter()
  const companyId = offer.company.id

  const company = useSelector(({ offers: { included } }) => included.companies[companyId])
  const technologie = useSelector(({ offers: { included } }) => included.technologies)
  const WILAYAS = getWilayasFromTranslation()

  const getDepartmentName = (departmentCode) => WILAYAS.find(({ code }) => parseInt(code) === departmentCode).name

  return (
    <Card className={classes.root} onClick={() => router.push(`/job-offer/${offer.hashid}`)}>
      <Hidden smDown>
        <CardMedia className={classes.logo} image={company.logo && pictureUrl(company.logo, 75 * 2, 75 * 2)} />
      </Hidden>
      <CardContent style={{ position: 'relative', width: '100%' }}>
        <Typography variant="h2" component="h2" className={classes.postLabel}>
          <a href={`/job-offer/${offer.hashid}`} className={classes.noLink}>
            {offer.label}
          </a>
        </Typography>
        <Typography variant="subtitle1" component="h2">
          {company && company.name}
        </Typography>
        <Typography variant="h6" component="h2">
          <RoomIcon fontSize="inherit" style={{ verticalAlign: 'middle' }} />
          <small>{company && getDepartmentName(company.departement_code)}</small>
          {offer.remote !== 'never' && <small> #remote_{offer.remote}</small>}
        </Typography>
        <Box style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}>
          {['pending', 'draft'].includes(offer.status) && <StatusChip label={<Trans i18nKey="main.offer_status.draft" />} style={{ color: '#A9A9A9', borderColor: 'currentColor' }} />}
          {offer.status === 'rejected' && <StatusChip label={<Trans i18nKey="main.offer_status.rejected" />} style={{ color: '#ec5858', borderColor: 'currentColor' }} />}
          {offer.status === 'terminated' && <StatusChip label={<Trans i18nKey="main.offer_status.terminated" />} style={{ color: '#03A678', borderColor: 'currentColor' }} />}
          {offer.status === 'paused' && <StatusChip label={<Trans i18nKey="main.offer_status.paused" />} style={{ color: '#F7CA18', borderColor: 'currentColor' }} />}
          {offer.status === 'special' && <StatusChip label={<Trans i18nKey="main.offer_status.special" />} style={{ color: '#A9A9A9', borderColor: 'currentColor' }} />}
        </Box>
        <Box bottom={0} right={0} position="absolute">
          {offer.technologies.slice(0, 3).map((technology) => (
            <Tooltip
              className={classes.tooltip}
              placement="top"
              TransitionComponent={Zoom}
              title={technologie[technology.id] && technologie[technology.id].label}
              key={technology.id}>
              <Avatar style={{ display: 'inline', marginLeft: 5 }}>
                <img style={{ borderRadius: '50%' }} src={technologie[technology.id].thumb} />
              </Avatar>
            </Tooltip>
          ))}
        </Box>
      </CardContent>
    </Card>
  )
}
